module.exports = __webpack_public_path__ + "static/media/buat_invoice.c20c7436.png";